

















import EditionModal from "../core/Modals/EditionModal.vue";
import { AuditApi } from "../api/AuditApi";
import { Audit } from "../models/Audit";
import Evenement = Audit.Evenement;
import EvenementModalEdit from "./EvenementModalPartials/EvenementModalEdit.vue";

export default {
    name: "EvenementModal",
    components: {
        EvenementModalEdit,
        EditionModal,
    },
    props: {
        auditId: Number,
        evenementId: Number,
        //forceEditing: Boolean,
        isNew: Boolean,
    },
    data() {
        return {
            showModal: false,
            evenement: null,
            fetching: true,
            editing: true,
            AuditApi: new AuditApi(),
        };
    },
    watch: {
        evenementId: function (newVal): void {
            var self = this;

            self.showModal =
                _.isNumber(newVal) && self.auditId && _.isNumber(self.auditId);
            if (self.showModal) {
                self.fetching = true;
                self.AuditApi.getEvenement(self.auditId, newVal, {
                    include: "photos,client",
                }).then(function (res) {
                    self.evenement = res;
                    self.fetching = false;
                });
            }
        },
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.evenement = new Evenement({});
                    this.creationModal();
                }
            },
        },
        /*forceEditing: function (newVal) {
            this.editing = newVal;
        },*/
    },
    methods: {
        closeModal: function (data): void {
            this.showModal = false;
            this.$emit("close-modal", data);
        },
        saveEvenement: function (): Promise<Evenement> {
            var self = this;

            return self.AuditApi.updateEvenement(self.evenement).then(function (
                res
            ) {
                self.$emit("data-saved", self.entry);
                return res;
            });
        },
        creationModal: function (): void {
            this.showModal = true;
            this.fetching = false;
            this.editing = true;
        },
    },
};
